export default __webpack_public_path__ + "static/media/bz.c1a4aca8.svg";